'use client';

import { useContext } from 'react';
import {
  ActiveWorkspaceContext,
  ConfirmedConvexIdentityContext,
} from '@/providers/workspace-identity-context';
import { storageUrlCacheScope } from './storage-url-cache';

/**
 * The client-side memory scope this render resolves storage URLs under: the
 * confirmed identity and, under an admitted workspace, its slug. Null while no
 * identity is confirmed.
 *
 * Client-only. The identity here is the Better Auth subject, not the app
 * `users` id, so it is never sent to the server as an argument; the server
 * authorizes whoever is authenticated (#4747).
 */
export function useStorageUrlCacheScope(): string | null {
  const identity = useContext(ConfirmedConvexIdentityContext);
  const workspace = useContext(ActiveWorkspaceContext);
  const workspaceSlug =
    identity && workspace && workspace.userId === identity
      ? workspace.orgSlug
      : null;
  return storageUrlCacheScope(identity, workspaceSlug);
}
